import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsDetailCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsDetailCivilStatusOtherPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsDetailCivilStatusShared isOther scope={IdAmbito.Cancellazioni} />
    </Fragment>
  );
};

ResearchFamilyNotificationsDetailCivilStatusOtherPage.displayName =
  'Research Family Notifications CivilStatusOtherPage component';

export default ResearchFamilyNotificationsDetailCivilStatusOtherPage;
